<template lang="pug">
//- Diálogo de confirmação de operação
action-dialog-popup(
  v-bind="$props"
  :action="action"
  @actionComplete="completeAction"
  @actionTerminate="terminateAction"
)
</template>

<script>
import ActionDialogPopup from './ActionDialogPopup'

export default {
  components: {
    ActionDialogPopup,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    /**
     * Parâmetros da requisição.
     * @type {Object}
     *    Formato:
     *    {
     *      -- Link da ação
     *      link: {Keep.Paper.Design.Link},
     *      -- Registros afetados pela ação
     *      selection: {Array},
     *    }
     */
    request: Object,
  },

  data: () => ({
    /**
     * Link de ação da requisição.
     * @type {Keep.Paper.Design.Link}
     */
    action: null,
  }),

  watch: {
    'request': 'createAction',
  },

  methods: {
    completeAction(...args) {
      this.$emit('actionComplete', ...args)
    },

    terminateAction(...args) {
      this.action = null
      this.$emit('actionTerminate', ...args)
    },

    createAction() {
      try {
        if (!this.request) return

        const { link, selection } = this.request
        if (!link) return

        const form = this.request.form || link.form || {}
        const data = []

        selection?.forEach(item => {
          const row = {}
          Object.keys(item).forEach(key => {
            if (!key.startsWith('@')) {
              const cell = item[key]
              const value = (typeof cell === 'object') ? cell?.value : cell
              row[key] = value
            }
          })
          data.push(row)
        })

        this.action = { ...link }
        this.action.form = form
        this.action.data = data

      } catch (error) {
        this.action = null
        throw error
      }
    },
  },
}
</script>